// Identifiant d'appareil stable (anti-rejouer par device).
export const getDeviceId = () => {
  let id = localStorage.getItem("yum_device_id");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now() + Math.random());
    localStorage.setItem("yum_device_id", id);
  }
  return id;
};
